namespace GeniuzPOS.InitialData {
    export namespace PsDiscCouponTypeSerialService {
        export const baseUrl = 'InitialData/PsDiscCouponTypeSerial';

        export declare function Create(request: Serenity.SaveRequest<PsDiscCouponTypeSerialRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsDiscCouponTypeSerialRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsDiscCouponTypeSerialRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsDiscCouponTypeSerialRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "InitialData/PsDiscCouponTypeSerial/Create",
            Update = "InitialData/PsDiscCouponTypeSerial/Update",
            Delete = "InitialData/PsDiscCouponTypeSerial/Delete",
            Retrieve = "InitialData/PsDiscCouponTypeSerial/Retrieve",
            List = "InitialData/PsDiscCouponTypeSerial/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsDiscCouponTypeSerialService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
